module.exports = __webpack_public_path__ + "img/lens-174-minus-04.a958da48.png";